import React, { useState, useEffect } from "react";
import { Modal, Button, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const ReasonModal = ({
    open,
    title,
    onClose,
    onSubmit,
    initialReason = "",
    actionColor = "warning",
    submitText = "Confirm"
}) => {
    const [reasonText, setReasonText] = useState(initialReason);

    useEffect(() => {
        setReasonText(initialReason);
    }, [initialReason, open]);

    const handleSubmit = () => {
        if (reasonText.trim()) {
            onSubmit(reasonText);
            setReasonText(""); // reset after submit
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <MDBox
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    p: 3,
                    boxShadow: 24,
                }}
            >
                <MDTypography variant="h6" mb={2}>
                    {title}
                </MDTypography>

                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Enter reason..."
                    value={reasonText}
                    onChange={(e) => setReasonText(e.target.value)}
                />

                <MDBox mt={3} display="flex" justifyContent="flex-end" gap={1}>
                    {/* Cancel Button */}
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            color: "#6b7280",          // gray text
                            borderColor: "#6b7280",
                            "&:hover": {
                                bgcolor: "#f3f4f6",
                                borderColor: "#4b5563",
                            },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        disabled={!reasonText.trim()}
                        onClick={handleSubmit}
                        sx={{
                            bgcolor:
                                actionColor === "error"
                                    ? "#2e7d32" // red
                                    : actionColor === "warning"
                                        ? "#f59e0b" // orange
                                        : "#2563eb", // blue fallback
                            color: "#fff",
                            "&:hover": {
                                bgcolor:
                                    actionColor === "error"
                                        ? "#b91c1c"
                                        : actionColor === "warning"
                                            ? "#d97706"
                                            : "#1d4ed8",
                            },
                            "&.Mui-disabled": {
                                bgcolor: "#e5e7eb",
                                color: "#9ca3af",
                            },
                        }}
                    >
                        {submitText}
                    </Button>
                </MDBox>

            </MDBox>
        </Modal>
    );
};

export default ReasonModal;
